import { builtIn } from "./rules.js";
import { baseRules } from "./base.js";

export const html5 = builtIn({
  id: "html5",
  name: "HTML5",
  basedOn: "html5",
  description: "Semantic HTML5 using Word's built-in style names, shown with your browser's default styles. No classes to depend on.",
  rules: baseRules,
});
